export const protectedRoutes = [
  "my-account",
  "new-listing",
  "my-listings",
  "saved-listings",
  "chats",
  "dashboard",
];
